import { deleteCookie, getCookie, setCookie } from 'cookies-next';
import {
  compressToEncodedURIComponent,
  decompressFromEncodedURIComponent,
} from 'lz-string';
import type { WebStorage } from 'redux-persist';

export const cookieStorage: WebStorage = {
  getItem: async (key: string): Promise<string | null> => {
    const raw = getCookie(key);
    if (!raw || typeof raw !== 'string') return null;

    const decompressed = decompressFromEncodedURIComponent(raw);
    return decompressed ?? null;
  },
  setItem: async (key: string, value: string): Promise<void> => {
    const compressed = compressToEncodedURIComponent(value);
    setCookie(key, compressed, {
      path: '/',
      secure: true,
      sameSite: 'lax',
      domain: process.env.NEXT_PUBLIC_COOKIE_DOMAIN,
    } as any);
  },
  removeItem: async (key: string): Promise<void> => {
    deleteCookie(key);
  },
};
